import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { BondModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class IsfBondsRepository {
  constructor(private apiService: ApiService) {}

  public updateIsfBond(isfId: number, bond: BondModel): Observable<BondModel> {
    return this.apiService.put<BondModel>(`${environment.url.isf}${isfId}/bond`, bond);
  }

  public connectBondRequest(isfId: number, bondRequestId: number): Observable<never> {
    return this.apiService.put(`${environment.url.isf}${isfId}/bond-request-id`, bondRequestId);
  }

  public disconnectBondRequest(isfId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.isf}${isfId}/bond-request-id`);
  }
}
